import { Pin } from '@vis.gl/react-google-maps'

export const ExternalPhamarcyPin = (): JSX.Element => (
  <Pin
    background='#868c87'
    borderColor='#3e403f'
    glyphColor='#252726'
  />
)
